import { Component } from "@angular/core";
import { Address } from "@models";
import { CustomModal } from "../../../core/components/base-modals";

@Component({
	templateUrl: "./qr-modal.component.html",
	styleUrls: ["./qr-modal.component.scss"],
	standalone: false
})
export class QrModalComponent extends CustomModal {
	public address: Address = null;

	public get qr(): string {
		return this.data;
	}
}
